"use strict";
exports.__esModule = true;
var react_1 = require("react");
var GoogleMapContext = react_1.createContext({
    map: null,
    setMap: null,
    mapState: null,
    setMapState: null,
    children: null,
    setChildren: null,
    zoom: null,
    setZoom: null,
    bound: null,
    setBound: null,
    center: null,
    setCenter: null
});
exports.GoogleMapContext = GoogleMapContext;
